// import parse from 'html-react-parser';
import React from 'react';
import SwipeComponent from './SwipeComponent';

const Modal = (props) => {
  const { showModal, currentItem, closeModal, toNextItem, toPreviousItem } =
    props;

  return (
    <section className='modal-outer'>
      <SwipeComponent
        currentItem={currentItem}
        toNextItem={toNextItem}
        toPreviousItem={toPreviousItem}
        closeModal={closeModal}
      />
    </section>
  );
};

export default Modal;
